export default __webpack_public_path__ + "1fb710c67dcecf785a6101c507c9c9dd.ttf";